import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import FaqSection from "@/components/sections/FaqSection";
import PackagesGrid, { PackagesNote } from "@/components/PackagesGrid";
import { IMG } from "@/data/content";

export default function Packages() {
  return (
    <>
      <Seo title="Packages & Pricing | HM Services" description="Flexible hospitality growth packages — Starter, Basic, Growth and Premium — with custom pricing tailored to your property, platforms and services." path="/packages" image={IMG.villaPool} />
      <PageHero eyebrow="Packages" title="Choose Your Package" subtitle="Four flexible packages designed to meet your property wherever it is on its digital journey. Every package uses custom pricing based on your specific needs." image={IMG.villaPool} />

      <section className="bg-white py-24 lg:py-32" data-testid="packages-page">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <PackagesGrid />
          <PackagesNote />
        </div>
      </section>

      <FaqSection />
      <CTASection />
    </>
  );
}
